module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.76a12d3c.xml";